import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=f1076e4e"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"
import style0 from "./editor.vue?vue&type=style&index=0&id=f1076e4e&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/web_acadmin_online_docker/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1076e4e')) {
      api.createRecord('f1076e4e', component.options)
    } else {
      api.reload('f1076e4e', component.options)
    }
    module.hot.accept("./editor.vue?vue&type=template&id=f1076e4e", function () {
      api.rerender('f1076e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/template/editor.vue"
export default component.exports